// extracted by mini-css-extract-plugin
export var imageBlock = "ArticleImageBlock-module--imageBlock--257Dw";
export var imageWrapper = "ArticleImageBlock-module--imageWrapper--7DRRw";
export var image = "ArticleImageBlock-module--image--2SoqI";
export var overlayTextContainer = "ArticleImageBlock-module--overlayTextContainer--3DwZR";
export var overlayHeading = "ArticleImageBlock-module--overlayHeading--EZfgh";
export var overlayText = "ArticleImageBlock-module--overlayText--3fi6i";
export var imageCaption = "ArticleImageBlock-module--imageCaption--eeXs0";
export var separator = "ArticleImageBlock-module--separator--2Ppvq";
export var imageAuthorWebsite = "ArticleImageBlock-module--imageAuthorWebsite--3KP7t";